import {Helmet} from '@dr.pogodin/react-helmet';

import {useGetWatermarkQuery} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {formatDocumentTitle} from '@dms/shared';

import {WatermarkFormOld} from './components/WatermarkFormOld';

export function PhotosWatermarkingOld() {
  const {isLoading} = useGetWatermarkQuery();

  return (
    <>
      <Helmet
        title={formatDocumentTitle(
          i18n.t('page.salesSettings.labels.watermarks.name'),
          i18n.t('page.salesSettings.labels.advertising'),
          i18n.t('page.settings.labels.title')
        )}
      />
      <SettingsTemplate
        isLoading={isLoading}
        header={{
          title: i18n.t('page.salesSettings.labels.watermark'),
          breadcrumbs: [
            {
              label: i18n.t('page.salesSettings.labels.advertising'),
              href: settingsRoutes.advertising,
            },
          ],
        }}
        data-testid="settings-advertising-watermarking"
      >
        <WatermarkFormOld />
      </SettingsTemplate>
    </>
  );
}
